<template>
  <v-card flat>
    <v-app-bar fixed height="150" color="white">
      <v-card width="100%" dense flat color="transparent">
        <v-toolbar dense flat color="transparent">
          <v-spacer></v-spacer>
          <v-btn small text @click="$emit('activities')" color="primary"
            >Actividades</v-btn
          >
          |
          <v-btn disabled small text color="primary">Profesores</v-btn>
          |
          <v-btn disabled small text @click="$emit('students')" color="primary"
            >Alumnos</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat dense color="transparent">
          <v-text-field
            class="mx-0 px-0 pt-8"
            rounded
            outlined
            filled
            dense
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Buscar persona"
            @change="resolveField"
          ></v-text-field>
        </v-toolbar>
        <v-toolbar flat dense color="transparent">
          <v-spacer></v-spacer>
          <v-dialog v-if="!newStudents" width="600" v-model="newStudentDialog">
            <template v-slot:activator="{ on }">
              <v-btn
                text
                rounded
                v-on="on"
                color="primary"
                class="pa-0 px-2 ma-0"
              >
                <v-icon left>mdi-account-plus</v-icon>Nuevo alumno
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="font-weight-light"
                >Nuevo alumno</v-card-title
              >
              <v-card-text>
                <h2 class="my-2 overline">Datos del alumno</h2>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      dense
                      label="Nombre"
                      v-model="newStudent.name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <v-text-field
                      dense
                      label="Grupo"
                      v-model="newStudent.group"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <h2 class="my-2 overline">Datos del padre</h2>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      dense
                      label="Nombre del padre"
                      type="email"
                      v-model="newStudent.fatherName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      label="correo"
                      prepend-icon="mdi-at"
                      v-model="newStudent.fatherEmail"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      dense
                      label="móvil"
                      prepend-icon="mdi-cellphone-android"
                      v-model="newStudent.fatherCell"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      dense
                      label="fijo"
                      prepend-icon="mdi-phone"
                      v-model="newStudent.fatherPhone"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <h2 class="my-2 overline">Datos de la madre</h2>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      dense
                      label="Nombre de la madre"
                      v-model="newStudent.motherName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      label="correo"
                      prepend-icon="mdi-at"
                      v-model="newStudent.motherEmail"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      dense
                      label="móvil"
                      prepend-icon="mdi-cellphone-android"
                      v-model="newStudent.motherCell"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      dense
                      label="fijo"
                      prepend-icon="mdi-phone"
                      v-model="newStudent.motherPhone"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <h2 class="my-2 overline">Comentario</h2>
                <v-row dense>
                  <v-col dense cols="12">
                    <v-textarea
                      dense
                      rows="1"
                      auto-grow
                      label="Puedes añadir aquí cualquier comentario"
                      v-model="newStudent.comment"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn text @click="newStudentDialog = false">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="deep-purple darken-1" @click="createStudent"
                  >Aceptar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            text
            rounded
            color="primary"
            class="ma-0"
            v-if="newStudents"
            @click="addStudents"
          >
            <v-icon left>mdi-account-multiple-plus</v-icon>Añadir alumnos
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card>
    </v-app-bar>
    <v-card-text :style="{ 'margin-top': '140px' }">
      <v-card
        class="mx-0 my-3"
        :input-value="
          Object.keys(selected).length > 0 && selected.id === student.id
        "
        :key="index"
        v-for="(student, index) in students.filter((e) => {
          return (
            getOrderName(e.name).includes(getOrderName(search)) ||
            getOrderName(e.group).includes(getOrderName(search))
          );
        })"
        @click="
          selectStudent(student);
          $emit('select', student);
        "
      >
        <v-card-text class="ma-0 pa-0 pl-3 pt-2">
          {{ student.name }}
        </v-card-text>
        <v-card-text class="ma-0 pa-0 pl-3 pb-2">
          {{ showGroup(student.group) }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="font-weight-light">
          {{
            student.activities && Object.keys(student.activities).length > 0
              ? Object.keys(student.activities).length
              : ""
          }}
          <v-spacer></v-spacer>
          <v-btn icon x-small color="accent">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
/* eslint-disable */

import { students, newId } from "../firebaseConfig.js";

export default {
  props: ["list"],
  data() {
    return {
      selected: {},
      students: [],
      newStudentDialog: false,
      newStudent: {},
      search: "",
      results: 0,
      newStudents: [],
    };
  },
  created() {
    students.get().then((studentsRef) => {
      this.students = [];
      studentsRef.forEach((studentRef) => {
        this.students.push(studentRef.data());
      });
    });
  },
  methods: {
    selectStudent(student) {
      this.selected = student;
    },
    resolveField() {
      if(this.search.includes('$')) {
        let students = this.search.split('$');
        this.newStudents = [];
        students.forEach((student)=>{
          this.newStudents.push(student.split(';'))
        })
      }
    },
    showGroup(group) {
      if (group.length === 4) {
        let result = "";
        let section = group.substr(0, 2);
        let level = group[2];
        let line = group[3];
        switch (section) {
          case "00":
            result = "Infantil ";
            break;
          case "01":
            result = "Primaria ";
            break;
          case "02":
            result = "Secundaria ";
            break;
          case "03":
            result = "Bachillerato ";
            break;
          case "04":
            result = "BI ";
            break;
          case "05":
            result = "Pruebas ";
            break;
        }
        result += level + "º" + line;
        return result;
      } else {
        return "";
      }
    },
    createStudent() {
      let id = newId();
      let newStudent = {
        id: id,
        name: this.newStudent.name,
        group: this.newStudent.group,
        fatherName: this.newStudent.fatherName || "",
        fatherEmail: this.newStudent.fatherEmail || "",
        motherName: this.newStudent.motherName || "",
        motherEmail: this.newStudent.motherEmail || "",
        fatherPhone: this.newStudent.fatherPhone || "",
        motherPhone: this.newStudent.motherPhone || "",
        fatherCell: this.newStudent.fatherCell || "",
        motherCell: this.newStudent.motherCell || "",
      };
      students
        .doc(id)
        .set(newStudent)
        .then((studentRef) => {
          this.newStudentDialog = false;
          this.newStudent = {};
        });
    },
    selectStudent(student) {
    },
    getOrderName(str) {
      var theString = str.toLowerCase();
      return theString.replace(/[áàäâéèëêíìïîóòöôúùüûñç]/gi, (x) => {
        if ("áàäâ".indexOf(x) > -1) return "a";
        if ("éèëê".indexOf(x) > -1) return "e";
        if ("íìïî".indexOf(x) > -1) return "i";
        if ("óòöô".indexOf(x) > -1) return "o";
        if ("úùüû".indexOf(x) > -1) return "u";
        if (x === "ñ") return "nzzz";
        if (x === "ç") return "czzz";
      });
    },
    addStudents() {
      console.log("Añadir alumnos");
      this.newStudents.forEach((student) => {
        let newStudent = {
          id: newId(),
          name: student[0],
          birthday: new Date(),
          group: student[1],
          fatherName: student[2],
          fatherEmail: student[3],
          motherName: student[4],
          motherEmail: student[5],
          fatherPhone: student[8],
          motherPhone: student[9],
        };
        console.log(newStudent)
        students.doc(newStudent.id).set(newStudent);
      });
      this.search = null;
      this.newStudents = [];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
